export default {
  /* 显示隐藏头部 */
  headerShow: state => state.app.headerShow,
  /* 跳转链接 */
  forward: state => state.app.forward,
  /* 公共信息 */
  commonInfo: state => state.app.commonInfo,
  /* 极致游戏 logo */
  logo: state => {
    const logo = (state.app.commonInfo["jzyx_base_logo"] || []).find(
      el => el.unique_id === "mobile"
    );
    return (logo && logo.image) || "";
  },
  /* 页面离开标识 */
  leave: state => state.app.leave,
  /* 游戏列表 */
  gameList: state => {
    return state.app.gameList;
  },
  /* 商务合作 */
  businessLink: state => {
    const business = (state.app.commonInfo["jzyx_base_links"] || []).find(
      el => el.unique_id === "business"
    );
    return {
      title: (business && business.title) || "商务合作",
      href: (business && business.url) || "https://www.jzyx.com/business"
    };
  },
  /* vip */
  vipLink: state => {
    const vip = (state.app.commonInfo["jzyx_base_links_top"] || []).find(
      el => el.unique_id === "vip"
    );
    return {
      title: (vip && vip.title) || "",
      href: (vip && vip.url) || ""
    };
  },
  /* 人才招聘 */
  hrLink: state => {
    const job = (state.app.commonInfo["jzyx_base_menu"] || []).find(
      el => el.unique_id === "job"
    );
    return {
      title: (job && job.title) || "",
      href: (job && job.url) || ""
    };
  },

  /* 微博 */
  weibo: state => {
    const config = (state.app.commonInfo["jzyx_base_config"] || []).find(
      el => el.unique_id === "primary"
    );
    return {
      title: "新浪微博",
      href: (config && config.weibo) || ""
    };
  },

  /* 官方客服电话 */
  tel: state => {
    const config = (state.app.commonInfo["jzyx_base_config"] || []).find(
      el => el.unique_id === "primary"
    );
    return {
      title: "客服电话",
      tel: (config && config.phone_cs) || ""
    };
  },

  /* 微信公众号二维码 */
  wechat: state => {
    const config = (state.app.commonInfo["jzyx_base_config"] || []).find(
      el => el.unique_id === "primary"
    );
    return (config && config.image) || "";
  },

  /* 极致通行证注册协议 */
  protocol: state => {
    const protocol = (state.app.commonInfo["jzyx_base_links"] || []).find(
      el => el.unique_id === "protocol"
    );
    return {
      name: (protocol && protocol.title) || "通行证协议",
      url:
        (protocol && protocol.url) ||
        "https://ptweb-cms-res.jzyx.com/footer/1/passport.html"
    };
  },

  /* 隐私政策 */
  privacy: state => {
    const privacy = (state.app.commonInfo["jzyx_base_links"] || []).find(
      el => el.unique_id === "privacy"
    );
    return {
      name: (privacy && privacy.title) || "隐私政策",
      url:
        (privacy && privacy.url) ||
        "https://ptweb-cms-res.jzyx.com/footer/1/privacy.html"
    };
  },

  /* 关于我们 */
  aboutLink: state => {
    const about = (state.app.commonInfo["jzyx_base_links"] || []).find(
      el => el.unique_id === "about"
    );
    return {
      title: (about && about.title) || "公司简介",
      href: (about && about.url) || "https://www.jzyx.com/about"
    };
  },

  /* 极致产品 */
  gameLink: state => {
    const game = (state.app.commonInfo["jzyx_base_links_top"] || []).find(
      el => el.unique_id === "game"
    );
    return {
      title: (game && game.title) || "",
      href: (game && game.url) || ""
    };
  },

  /* 校园招聘 */
  campusLink: state => {
    const campus = (state.app.commonInfo["jzyx_base_menu"] || []).find(
      el => el.unique_id === "campus"
    );
    return {
      title: (campus && campus.title) || "",
      href: (campus && campus.url) || ""
    };
  }
};
